<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Vtex \ <span class="ActiveURL">Brand</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Brand Master Upload</h6>

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link> -->
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row> 
            <d-col>        
              <d-form id="pricing">
                <d-form-row>
                 
               
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Brand Master file *</label>
                    <div class="col-md-7" v-if="BrandMasterUpload.DataModel.UIData.UploadedDataCount == 0">   
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <d-button type="button" id="submit" title="Please Select the panel" class="btn-accent" @click="BrandMasterUploadData" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="BrandMasterUpload.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ BrandMasterUpload.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>

                 <d-col md="12" class="form-group row" v-if="BrandMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{BrandMasterUpload.DataModel.Data.SynccentricScrapList}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="BrandMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Rejected</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{BrandMasterUpload.DataModel.UIData.RejectedList.length}}</label>
                    </div>
                 </d-col>
                
                <d-col md="12" class="form-group row"  v-if="BrandMasterUpload.DataModel.UIData.UploadStatus" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="BrandMasterUpload.DataModel.UIData.RejectedList"  :name="BrandMasterUpload.DataModel.UIData.MinMaxFileName"><span style="marige-top:10px;" > Download Reject List </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                <div class style="text-align:center"  v-if="BrandMasterUpload.DataModel.UIData.UploadStatus">
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>         
 

                </d-form-row>

                <br />

              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="BrandMasterUpload.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: 'BrandMasterUpload',
   data() {
    return {
      BrandMasterUpload: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            BrandMaster:null,
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            RejectedList:[],
            AvailablityTemplate:[],
            BrandMasterList:[],
            AvailablityList:[],
            AvailablityTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.BrandMasterUpload.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.BrandMasterUpload.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      // this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.BrandMasterUpload.DataModel.Data.FromCountry = null;
     this.BrandMasterUpload.DataModel.UIData.UploadedDataCount = 0;
     this.ClearUsersetup();
     document.getElementById("pricing").reset();
},

panelOnchange(){

            this.BrandMasterUpload.DataModel.UIData.Template=[];
            this.BrandMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.BrandMasterUpload.DataModel.UIData.Template = [];
            this.BrandMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
            this.BrandMasterUpload.DataModel.Data.SynccentricScrapList = 0;
            this.BrandMasterUpload.DataModel.UIData.UploadStatus = false;
        this.BrandMasterUpload.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.BrandMasterUpload.DataModel.Data.FromCountry =null;
        this.BrandMasterUpload.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

getQuery()
{
      let vm = this;
      vm.BrandMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.BrandMasterUpload.DataModel.Data.Token = Token;
      this.BrandMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      var dataString = JSON.stringify(this.BrandMasterUpload.DataModel.Data);

      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.BrandMasterUpload.PageLoad = false;
            vm.BrandMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.UpDateBrandMasterUploadsMaster();
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.BrandMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},


UpDateBrandMasterUploadsMaster()
{
      let vm = this;
      vm.BrandMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.BrandMasterUpload.DataModel.Data.Token = Token;
      this.BrandMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      this.BrandMasterUpload.DataModel.Data.QueryString = "update AmazonBrandMaster tgt  , BrandMasterUploadsMaster src SET tgt.Handling_Time =  src.BrandMasterUploads , tgt.price = src.Price WHERE src.sku = tgt.seller_sku";
      var dataString = JSON.stringify(this.BrandMasterUpload.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.BrandMasterUpload.PageLoad = false;
            vm.BrandMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.ClearBrandMasterUploadsMaster();
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.BrandMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},

ClearBrandMasterUploadsMaster()
{
      let vm = this;
      vm.BrandMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.BrandMasterUpload.DataModel.Data.Token = Token;
      this.BrandMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      this.BrandMasterUpload.DataModel.Data.QueryString = "truncate TABLE BrandMasterUploadsMaster";
      var dataString = JSON.stringify(this.BrandMasterUpload.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.BrandMasterUpload.PageLoad = false;
            vm.BrandMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.$toaster.success("Updated Successfully.");
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.BrandMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},

      BrandMasterUploadData(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.BrandMasterUpload.DataModel.Data.Token = Token;
      this.BrandMasterUpload.DataModel.Data.CRUD = "BrandMasterCreate";
      this.BrandMasterUpload.DataModel.UIData.UploadStatus = false;
      this.BrandMasterUpload.DataModel.UIData.RejectedList=[];
      this.BrandMasterUpload.DataModel.UIData.BrandMasterList.map(function(value,key){

      vm.BrandMasterUpload.DataModel.Data.BrandMaster = Utilities.JsonCopy(value);
      var dataString = JSON.stringify(vm.BrandMasterUpload.DataModel.Data);
      vm.BrandMasterUpload.PageLoad = true;
      vm.BrandMasterUpload.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.BrandMasterUpload.PageLoad = false;
            if(response.data.Result!=1)
            {
              vm.$toaster.error("record Not saved.");
                response.data.Result.Error = response.data.Result.Error.message;              
                vm.BrandMasterUpload.DataModel.UIData.RejectedList.push(Utilities.JsonCopy(response.data.Result));
                console.log(response.data.Result);
            }
            else
            {
              vm.$toaster.success("Save Successfully.");
            }
             console.log(response.data.Result);  
             vm.BrandMasterUpload.DataModel.UIData.UploadedDataCount = 1;
              console.log(response.data.ErrorInfo);
              vm.BrandMasterUpload.PageLoad = false;
          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.BrandMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      });
     vm.BrandMasterUpload.DataModel.UIData.UploadStatus = true;
      },

  // UploadedDataCount

    AmazonTemplate(dataString){
       let vm = this;
        vm.BrandMasterUpload.DataModel.Data.CRUD = "GetAmazonList";
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.BrandMasterUpload.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);

            response.data.Result.map(function(key,value){

                key.minimum_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                key.maximum_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));

            });

            vm.BrandMasterUpload.DataModel.UIData.Template = response.data.Result;
            
            if(vm.BrandMasterUpload.DataModel.UIData.Template.length > 0)
            vm.BrandMasterUpload.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.BrandMasterUpload.PageLoad = false;
              vm.$swal.fire("Oops...", "Something went wrong !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.BrandMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },


    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.BrandMasterUpload.PageLoad = true;
      this.BrandMasterUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.BrandMasterUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.BrandMasterUpload.DataModel.Data.SynccentricScrapList = 0 ;
          this.BrandMasterUpload.DataModel.Data.QueryString = "INSERT INTO `STWBrandMaster` (`Name`, `Text`, `Keywords`, `SiteTitle`, `Active`, `MenuHome`, `AdWordsRemarketingCode`, `LomadeeCampaignCode`, `Score`, `LinkId`) VALUES";
          this.BrandMasterUpload.DataModel.UIData.BrandMasterList = [];

          for (var i = 0; i < ws.length; i++) {

            var BrandData={
                Id:null,
                Name:null, 
                Text:0, 
                Keywords:0, 
                SiteTitle:0, 
                Active:0, 
                MenuHome:0, 
                AdWordsRemarketingCode:0, 
                LomadeeCampaignCode:null, 
                Score:null, 
                LinkId:null
            }


            if(ws[i].Name !=undefined)
            {
                BrandData.Name = ws[i].Name;
            }
            else
            {
              BrandData.Name = null;
            }

            if(ws[i].Name !=undefined)
            {
                BrandData.Name = ws[i].Name;
          
            }
            else
            {
              BrandData.Name = null;
            }

            if(ws[i].Text !=undefined)
            {
                BrandData.Text = ws[i].Text;
          
            }
            else
            {
              BrandData.Text = null;
            }

            if(ws[i].Keywords !=undefined)
            {
                BrandData.Keywords = ws[i].Keywords;
            }
            else
            {
              BrandData.Keywords = null;
            }

            if(ws[i].SiteTitle !=undefined)
            {
                BrandData.SiteTitle = ws[i].SiteTitle;
            }
            else
            {
              BrandData.SiteTitle = null;
            }            
            
            if(ws[i].Active !=undefined)
            {
                BrandData.Active = ws[i].Active;
            }
            else
            {
              BrandData.Active = null;
            }          

            if(ws[i].MenuHome !=undefined)
            {
                BrandData.MenuHome = ws[i].MenuHome;
            }
            else
            {
              BrandData.MenuHome = null;
            }           
            
            if(ws[i].AdWordsRemarketingCode !=undefined)
            {
                BrandData.AdWordsRemarketingCode = ws[i].AdWordsRemarketingCode;
          
            }
            else
            {
              BrandData.AdWordsRemarketingCode = null;
            }            
            
            if(ws[i].LomadeeCampaignCode !=undefined)
            {
                BrandData.LomadeeCampaignCode = ws[i].LomadeeCampaignCode;
            }
            else
            {
              BrandData.LomadeeCampaignCode = null;
            }           
            
            if(ws[i].Score !=undefined)
            {
                BrandData.Score = ws[i].Score;
            }
            else
            {
              BrandData.Score = null;
            }           
            
            if(ws[i].LinkId !=undefined)
            {
                BrandData.LinkId = ws[i].LinkId;
            }
            else
            {
              BrandData.LinkId = null;
            }           

             BrandData.CreatedBy = this.BrandMasterUpload.SessionInfo.PageInfo.userId;

            this.BrandMasterUpload.DataModel.Data.QueryString = this.BrandMasterUpload.DataModel.Data.QueryString + "(\'" + BrandData.SKU + "\',\'" +BrandData.BrandMasterUploads + "\')";

            if(i < (ws.length - 1))
            {
              this.BrandMasterUpload.DataModel.Data.QueryString = this.BrandMasterUpload.DataModel.Data.QueryString+"," 
            }
            this.BrandMasterUpload.DataModel.Data.SynccentricScrapList +=1;
            
            this.BrandMasterUpload.DataModel.UIData.BrandMasterList.push(BrandData);
            //  excellist.push(ws[i]);
          }

          
           this.BrandMasterUpload.DataModel.Data.QueryString = this.BrandMasterUpload.DataModel.Data.QueryString+";"
          // console.log("Read results", this.BrandMasterUpload.DataModel.Data.SynccentricScrapList); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log('headers', this.BrandMasterUpload.DataModel.Data.SynccentricScrapList);  
          this.BrandMasterUpload.PageLoad = false;
           console.log(this.BrandMasterUpload.DataModel.Data.QueryString); 
          // this.BrandMasterUpload.DataModel.Data.QueryString = JSON.stringify(this.BrandMasterUpload.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.BrandMasterUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },

    previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }
  }
}
</script>